import { Controller } from 'stimulus'
import renderDirectUpload from '../templates/direct_upload.js'

export default class DirectUploadController extends Controller {
  static targets = [ 'input' ]

  // direct-upload:initialize
  before_start(event) {
    const { id, file } = event.detail
    $(this.inputTarget).before(renderDirectUpload(id, file))
    $(`#direct-upload-progress-${id}`).width('0%')
  }

  // direct-upload:start
  start(event) {
    this.directUploadElement(event).removeClass('direct-upload--pending')
  }

  // direct-upload:progress
  progress(event) {
    const { id, progress } = event.detail
    const progressElement = $(`#direct-upload-progress-${id}`)
    progressElement.width(`${progress}%`)
  }

  // direct-upload:error
  error(event) {
    event.preventDefault()
    const { id, error } = event.detail
    this.directUploadElement(event).addClass("direct-upload--error").attr('title', error)
  }

  // direct-upload:end
  end(event) {
    this.directUploadElement(event).addClass("direct-upload--complete")
  }

  directUploadElement(event) {
    const { id } = event.detail
    return $(`#direct-upload-${id}`)
  }
}


